var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDomains = function SvgDomains(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#domains_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.009 6.5H8.99c-.05-1.403-.308-2.645-.685-3.55-.21-.507-.45-.884-.69-1.127-.233-.237-.437-.32-.607-.323H6.99c-.169.003-.373.086-.607.323-.24.243-.478.62-.69 1.127-.376.905-.634 2.147-.684 3.55m3.982 1c-.05 1.403-.308 2.645-.685 3.55-.21.507-.45.885-.69 1.128-.237.241-.445.322-.616.322s-.38-.08-.617-.322c-.24-.243-.478-.62-.69-1.127-.376-.906-.634-2.148-.684-3.55zm1 0h2.487a5.5 5.5 0 0 1-3.618 4.678q.203-.342.37-.743c.435-1.046.712-2.423.762-3.935m2.487-1H9.992c-.05-1.511-.327-2.889-.763-3.935a6 6 0 0 0-.37-.742A5.5 5.5 0 0 1 12.479 6.5m-8.47 0H1.522A5.5 5.5 0 0 1 5.14 1.823a6 6 0 0 0-.37.742C4.336 3.611 4.06 4.99 4.009 6.5m0 1H1.522a5.5 5.5 0 0 0 3.618 4.678 6 6 0 0 1-.37-.743C4.336 10.39 4.06 9.012 4.009 7.5M.5 7A6.5 6.5 0 0 1 6.983.5h.034A6.5 6.5 0 1 1 .5 7",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "domains_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDomains);
export default ForwardRef;